"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import SlotOrientationDiagram from "@/components/diagrams/SlotOrientationDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function AxialSlotCylindersPage() {
  const {
    lang
  } = useLanguage();
  const pageData = pick(lang, COPY);
  const {
    content,
    diagramCopy
  } = pageData;
  const diagramSlot = <DiagramSection id="axial-diagram" title={diagramCopy.sectionTitle} lead={diagramCopy.sectionLead} tone="background">
      <div className="max-w-2xl mx-auto">
        <DiagramCard index="01" badge="Axial Slot Alignment" title={content.hero.heading} description={diagramCopy.sectionLead}>
          <SlotOrientationDiagram orientation="axial" />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagramSlot} />;
}